import { render, staticRenderFns } from "./antenatal.vue?vue&type=template&id=9cb2c422&scoped=true&"
import script from "./antenatal.vue?vue&type=script&lang=js&"
export * from "./antenatal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb2c422",
  null
  
)

export default component.exports